import React from 'react';
import { Radio as RadioNew } from './Radio';
import { convertOldRadioProps } from './converter.old';
import type { OldRadioProps } from './converter.old';

export type RadioProps = OldRadioProps;

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>((props, ref) => (
  <RadioNew {...convertOldRadioProps(props)} ref={ref} />
));
